import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import { fetchNotificationListData } from "../thunks/notificationListThunk";

interface NotificationListState {
  notificationList: any[];
  loading: boolean;
  error: string | null;
  isDataFetched?: boolean;
}

const initialState: NotificationListState = {
  notificationList: [],
  loading: false,
  error: null,
  isDataFetched: false,
};

export const notificationListSlice = createSlice({
  name: "notificationList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationListData.pending, (state) => {
        state.loading = true;
        state.isDataFetched = true;
      })
      .addCase(fetchNotificationListData.fulfilled, (state, action) => {
        state.notificationList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchNotificationListData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isDataFetched = false;
        state.loading = false;
      });
    addWebSocketCases(builder, "notificationList", "notificationList");
  },
});

export default notificationListSlice.reducer;
